function EmailVerificationPrompt({
  APIEndpoint,
  refreshAccountDetails,
}) {
  const resendVerification = APIEndpoint.post('/accounts/email-verification/resend')

  let isOpen = null
  let attemptsRemaining = null
  let hadSuccess = false
  return {
    attemptsRemaining() {
      return attemptsRemaining
    },
    canDismiss() {
      return hadSuccess
          || isRateLimited()
    },
    className() {
      return 'email-verification-prompt' + (hadSuccess ? ' success' : '')
    },
    dismissButtonClassName() {
      return `btn btn-small ${isRateLimited() ? 'btn-borderless ' : ''}dismiss-prompt-btn`
    },
    isShowing() {
      return isOpen === true
    },
    isRateLimited,
    hadSuccess() {
      return hadSuccess
    },
    handleAccountRefresh(account) {
      if (account) {
        attemptsRemaining = account.emailVerificationAttemptsRemaining
        isOpen = account.emailIsVerified === false
              && (isOpen === null ? true : isOpen)
      } else {
        isOpen = false
      }
    },
    dismiss() {
      isOpen = false
    },
    resendVerification() {
      resendVerification()
        .then(() => {
          hadSuccess = true
        })
        .catch(res => {
          if (res.status === 429) {
            attemptsRemaining = 0
          } else {
            console.error(res)
          }
        })
        .finally(() => refreshAccountDetails())
    },
    __proto__: EmailVerificationPrompt.prototype,
  }

  function isRateLimited() {
    return attemptsRemaining <= 0
  }
}

Object.assign(exports, { EmailVerificationPrompt })
